export enum TargetApiEnum {
  WP_API = 'wpApi',
  PC_API = 'pcApi',
}
